import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Whatmob() {
  return (
    <section className="what_mob p-100 text_peanut">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              What We <span>Did?</span> 
            </h2>
            <p>
              TekRevol development experts and strategists took a careful look
              at the idea and its pain points and features. We helped refine it
              and proposed a comprehensive solution to effectively complete the
              project.
            </p>
            <div className="what_mob_img">
              <StaticImage
                src="../../../images/case-studies/peanut/what_mob_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1095}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whatmob;
